import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import auth from '@/common/auth';
import Vue from 'vue';
import DigitalParametersMixin from '@/common/mixins/digitalHelper';
/* ----- mixin for controlling the Integration flow(like Header Enrichment configuration) ------

 If an integration is configured:
 - when user presses register button, the below actions/steps are executed (in order):
 registrationRedirect()
 -> getPreRedirectionAction()  [execute appropriate actions (of active integration) before redirect user]
 -> integrationRedirect() (or register1) [get the partner url from backend, if no url go to register1]
 -> redirection to partner (or register2)  [user is redirected to partner url or to register2 page]

 - when partner redirect user (with their response) to visitor (or other) page, the below step is executed:
 getIntegrationParametersCheck()

 - when user un-sub from Duel, the below action is executed (for now, only on Vodacom needed):
 getPostUnSubAction()

 So, when a new integration need to be added, its logic need to be implemented on methods:
 getPreRedirectionAction(), getIntegrationParametersCheck(), getPostUnSubAction() [if needed]
 and use them appropriately from different components (visitor, index, signup etc)
 */
const moment = require('moment/moment');

Vue.use(require('vue-moment'), {
  moment,
});

const IntegrationMixin = {
  mixins: [DigitalParametersMixin],
  data() {
    return {
      showLoadingModal: false,
      HE_ERROR_CODE: false,
      HE_LOGIN_INFO: false,
      SHOW_OPERATOR_CHOICE: false,
      ERROR_REDIRECT_MESSAGE: '',
      SHOW_HE_ERROR_RESPONSE_CODE_MESSAGE: false,
      errorStatusCode: '',
      REGISTRATION_ENDPOINT: 'api/getRegisterUrl',
    };
  },
  methods: {
    ...mapActions('common', [
      'getDecodedStatus',
      'getUserExistsInCore',
      'getUserIsRegistered',
      'updateIntegrationInfo',
      'reOptinProcess',
      'storeOperator',
    ]),
    ...mapActions('profile', [
      'clearAllData',
    ]),
    ...mapMutations('common', [
      'setOneTimeSubscriptionBundleId',
      'updateMultiOperatorOrdinal',
      'setUserLanguage',
      'updateRefUrl',
      'updateCampaignId',
      'updatePublisherId',
      'storeClickid',
      'setShowSelectOperatorModal',
      'facebookReferral',
      'setCorrelationId',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'getUserLoginDetails',
      'storeLoginInfo',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    registrationRedirect() {
      this.getPreRedirectionAction()();
    }, // 1st Step
    getPreRedirectionAction() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.TPAY_EGYPT.name: return () => {
        if (this.multiOperatorInfo.multiOperatorEnabled) {
          this.toggleSelectOperatorModal(true);
        } else {
          this.$router.push('register1');
        }
      };
      case this.availableIntegrations.ORANGE_SENEGAL.name: return () => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
      };
      case this.availableIntegrations.ORANGE_EGYPT.name: return () => {
        this.integrationRedirect();
      };
      case this.availableIntegrations.ETHIOTEL_ETHIOPIA.name: return () => {
        window.location.href = `${window.location.origin}/api/getRegisterUrl?lang=${this.getLocale || ''}`;
      };
      case this.availableIntegrations.KSA_MOBILY.name: return () => {
        window.location.href = `${window.location.origin}/api/getRegisterUrl?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}&lang=${this.getLocale || ''}`;
      };
      case this.availableIntegrations.ETISALAT_AFG.name: return () => {
        window.location.href = `${window.location.origin}/api/checkHe?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}&lang=${this.getLocale || ''}`;
      };
      case this.availableIntegrations.VODACOM.name: return () => {
        this.$axios.get('api/getUsageAuthRateUrl').then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            const parsedResponse = JSON.parse(res.data.data);
            if (parsedResponse.result === 'UNSUB') { // if user unsub to vodacom
              this.setActiveIntegrationInfo([{ key: 'packageId', value: parsedResponse.packageId }]);
              this.integrationRedirect();
            } else { // if user already sub to vodacom
              this.$axios.get(`api/getStatus?status=7&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((response) => {
                const statusResult = response.data.data[0];
                if (statusResult === 'ALREADY_REGISTERED') {
                  this.HE_LOGIN_INFO = true;
                } else if (statusResult === 'SUCCESS') { // success case
                  this.setRegistrationInfo(response.data.data[1]);
                  this.$router.push('register3');
                } else {
                  this.$router.push('/');
                }
              });
            }
          } else if (res.data.data === 'NO_TOKEN') this.HE_ERROR_CODE = true; // server error case
        });
      };
      case this.availableIntegrations.VIVA_KUWAIT.name: return () => {
        this.setActiveIntegrationInfo([{ key: 'lang', value: this.getLocale }]);
        this.integrationRedirect();
      };
      case this.availableIntegrations.DU_ETISALAT.name: return () => {
        if (this.multiOperatorInfo.multiOperatorEnabled) {
          this.toggleSelectOperatorModal(true);
        } else {
          this.$router.push('register1');
        }
      };
      case this.availableIntegrations.OMANTEL_OMAN.name:
      case this.availableIntegrations.OOREDOO_OMAN.name: return () => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}`;
      };
      case this.availableIntegrations.YAS_TANZANIA.name: return () => {
        // window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}`;
        this.$router.push('register1');
      };
      default: return () => {
        this.$router.push('register1');
      };
      }
    }, // 2nd Step
    integrationRedirect() {
      const activeIntegration = this.getIntegrationByName();
      let url = this.REGISTRATION_ENDPOINT;
      const numOfParameters = activeIntegration.value.info.length;
      if (numOfParameters) url = `${url}?`;
      activeIntegration.value.info.forEach((element, index) => {
        url = `${url}${element.key}=${element.value}`;
        if (index + 1 !== numOfParameters) url = `${url}&`;
      });
      this.storeParametersToBrowserStorage();
      if (activeIntegration.value.storeDigitalParams) {
        url = `${url}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}`;
      }
      this.$axios.get(url).then((response) => {
        const responseEnum = response.data.responseEnum;
        let redirectionUrl = response.data.data;
        if (responseEnum === 'OPERATION_SUCCESS') {
          this.toggleSelectOperatorModal(false);
          if (redirectionUrl && redirectionUrl.startsWith('http')) {
            if (activeIntegration.value.transferDigitalParams) {
              redirectionUrl = `${redirectionUrl}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
            }
            window.location.href = redirectionUrl;
          } else {
            sessionStorage.setItem('msisdn', redirectionUrl);
            this.$router.push('register2');
          }
        } else {
          this.ERROR_REDIRECT_MESSAGE = responseEnum;
        }
      });
    }, // 3rd Step
    getIntegrationParametersCheck() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.TPAY_EGYPT.name: return (to) => {
        const { status, sessionToken, cid } = to.query;
        if (status) {
          if (status === 'Error') { // wifi
            this.setCorrelationId({ value: cid || '' });
            sessionStorage.setItem('sessionToken', sessionToken);
            if (to.path === '/forgotPassword1') {
              const forgotMsisdn = sessionStorage.getItem('forgotMsisdn');
              const forgotOperator = sessionStorage.getItem('forgotOperator');
              this.storeOperator(forgotOperator);
              this.getAlternateRequestPinAction()(forgotMsisdn, forgotOperator);
            } else {
              this.toggleSelectOperatorModal(true);
            }
          }
        } else this.showPage(true);
        this.proceedToAutoLogin(to);
      };
      case this.availableIntegrations.VODACOM.name: return (to) => {
        if (to.query.result && to.query['status-code']) {
          if (to.query.result === 'ACCEPTED' || to.query.result === 'ERROR') { // ERROR accepted in case of vodacom already registered
            const params = JSON.parse(sessionStorage.getItem('params') || JSON.stringify(''));
            if (params) {
              const clickid = params.clickid;
              this.storeClickid({ clickid });
              const refUrl = params.refUrl;
              this.updateRefUrl({ refUrl });
              const campaignId = params.campaignId;
              this.updateCampaignId({ campaignId });
              const publisherId = params.publisherId;
              this.updatePublisherId({ publisherId });
            }
            this.$axios.get(`api/getStatus?status=${to.query['status-code']}&correlationId=${to.query['client-txn-id']}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((response) => {
              const statusResult = response.data.data[0];
              if (statusResult === 'ALREADY_REGISTERED') {
                this.HE_LOGIN_INFO = true;
              } else if (statusResult === 'SUCCESS') { // success case
                this.setRegistrationInfo(response.data.data[1]);
                this.$router.push('register3');
              } else {
                if (to.query['status-code'] !== '0' && to.query['status-code'] !== '7') {
                  this.errorStatusCode = to.query['status-code'];
                  this.SHOW_HE_ERROR_RESPONSE_CODE_MESSAGE = true;
                }
                this.$router.push('/');
              }
            });
          } else {
            this.errorStatusCode = to.query['status-code'];
            this.SHOW_HE_ERROR_RESPONSE_CODE_MESSAGE = true;
          }
        }
      };
      case this.availableIntegrations.ORANGE_EGYPT.name: return (to) => {
        if (to.query.msisdn && to.query.status) {
          // eslint-disable-next-line
          const msisdn = to.query.msisdn;
          this.getDecodedStatus(to.query.status).then((res) => {
            this.setRegistrationInfo(encodeURIComponent(msisdn));
            const status = res.data;
            if (status === 'SUCCESS') {
              this.registerCheck(msisdn);
            }
          });
        }
      };
      case this.availableIntegrations.VIVA_KUWAIT.name: return (to) => {
        const userMsisdn = to.query.CGMSISDN;
        const userStatus = to.query.CGSTATUS;
        if (userMsisdn && userStatus) {
          this.$axios.get(`api/getStatus?status=${userStatus}&token=${userMsisdn}`).then((res) => {
            const statusResult = res.data;
            if (statusResult === 'FAILURE' || statusResult === 'BLACKLISTED') {
              this.$router.push('/');
            } else if (statusResult === 'ALREADY_REGISTERED') {
              this.$router.push('login');
            }
          });
        }
      };
      case this.availableIntegrations.DU_ETISALAT.name: return (to) => {
        if (this.multiOperatorInfo.multiOperatorEnabled) {
          const correlationId = to.query.correlatorId;
          const userStatus = to.query.statusCode;
          if (correlationId && userStatus) {
            this.$axios.get(`api/getStatus?status=${userStatus}&correlationId=${correlationId}&lang=${this.getLocale}`).then((res) => {
              const statusResult = res.data.data[0];
              if (statusResult === 'FAILURE') {
                this.$router.push('/');
              } else if (statusResult === 'ALREADY_REGISTERED') {
                this.$router.push('login');
              } else if (statusResult === 'SUCCESS') {
                this.setRegistrationInfo(res.data.data[1]);
                this.storeOperator(res.data.data[2]);
                this.facebookReferral({ fbRef: res.data.data[3] });
                if (res.data.data[4] === 'true') {
                  this.$gtm.trackEvent({
                    event: 'CompleteRegistrationDU',
                    category: 'MSISDN Registration',
                    action: 'Register 2 registration',
                    label: 'Register 2',
                  });
                }
                this.storeLoginInfo({
                  token: res.data.data[5],
                  rememberMeParameter: true,
                  username: res.data.data[6],
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            });
          }
          this.proceedToAutoLogin(to);
        }
      };
      case this.availableIntegrations.IRAQ_ZAIN.name: return (to) => {
        const userMsisdn = to.query.msisdn;
        const hash = to.query.msisdnencrypted;
        const correlationId = to.query.uniqid;
        const status = to.query.success;
        if (userMsisdn && hash) { // 3G case
          this.showLoadingModal = true;
          this.$axios.get(`api/getStatus?msisdn=${userMsisdn}&hashedMsisdn=${hash}&lang=${this.getLocale}&correlationId=${correlationId}&status=${status}`).then((res) => {
            this.showLoadingModal = false;
            if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
              const hasSub = res.data.data.isSub;
              if (hasSub === 'true') {
                this.$gtm.trackEvent({
                  event: 'CompleteRegistration',
                  category: 'MSISDN Registration',
                  action: 'Register 2 registration',
                  label: 'Register 2',
                });
              }
              this.storeLoginInfo({
                token: res.data.data.user_auth_token,
                rememberMeParameter: false,
                username: res.data.data.username,
              });
              this.getUserLoginDetails().then(() => {
                this.updateUserLanguage();
                this.$router.push('home');
              });
            }
          }).catch(() => {
            this.showLoadingModal = false;
          });
        } else if (correlationId) { // wifi case
          this.$router.push('register1');
        } else {
          this.proceedToAutoLogin(to); // check for autologin request
        }
      };
      case this.availableIntegrations.VIVA_BAHRAIN.name: return (to) => {
        if (to.query.user_auth_token && to.query.username) {
          this.proceedToAutoLogin(to);
        } else this.showPage(true);
      };
      case this.availableIntegrations.KOREK_IRAQ.name: return (to) => {
        if (to.query.user_auth_token && to.query.username) {
          this.proceedToAutoLogin(to);
        } else this.showPage(true);
      };
      default: return (to) => {
        this.proceedToAutoLogin(to);
        // eslint-disable-next-line
        console.log('No parameter check ( parameters: ' + to.query + ') for active integration: ' + this.integrationHeader);
      };
      }
    }, // 4th Step (when partner redirects user back to us again)
    proceedToAutoLogin(to) {
      // eslint-disable-next-line
      console.log('No parameter check ( parameters: ' + to.query.user_auth_token + ') for active integration: ' + to.query.username);
      if (to.query.user_auth_token && to.query.username) {
        this.storeLoginInfo({
          token: to.query.user_auth_token,
          rememberMeParameter: true,
          username: to.query.username,
        });
        this.getUserLoginDetails().then(() => {
          this.updateUserLanguage();
          this.$router.push('home');
        });
      }
    },

    getAlternateRequestPinAction(isDailySubscription) {
      switch (this.integrationHeader) {
      case this.availableIntegrations.OMANTEL_OMAN.name:
      case this.availableIntegrations.OOREDOO_OMAN.name: return () => {
        this.message = '';
        this.waitForResponse = true;
        const path = `publicapi/requestPinIntegration?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.operatorPicked}&isDefaultSubscription=${isDailySubscription}`;
        this.$axios.get(path).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.user.msisdn = '';
            this.setRegistrationInfo(response.data.data[0]);
            this.setOneTimeSubscriptionBundleId(response.data.data[1]);
            this.storeOperator(this.operatorPicked);
            this.$router.push('register2');
            this.waitForResponse = false;
          } else {
            this.mapErrorMessages(resp);
            this.hasErrors = true;
            this.waitForResponse = false;
          }
        });
      };
      case this.availableIntegrations.ORANGE_SENEGAL.name: return () => {
        const userMsisdn = this.user.msisdn;
        this.$axios.get(`publicapi/requestPinBizao?msisdn=${userMsisdn}`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            sessionStorage.setItem('userId', res.data.data.userId);
            sessionStorage.setItem('msisdn', userMsisdn);
            this.$router.push('/register2');
          } else if (res.data.responseEnum === 'ALREADY_REGISTERED') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
          } else if (res.data.responseEnum === 'WRONG_PIN') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'WRONG_PIN';
          } else if (res.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(res.data.responseEnum);
        });
      };
      case this.availableIntegrations.DRC_ORANGE.name: return () => {
        const userMsisdn = this.user.msisdn;
        this.$axios.get(`api/requestPinForLisano?msisdn=${userMsisdn}&hidden=true`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            sessionStorage.setItem('challengeId', res.data.data.challengeId);
            sessionStorage.setItem('msisdn', userMsisdn);
            this.$router.push('/register2');
          } else if (res.data.responseEnum === 'ALREADY_REGISTERED') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
          } else if (res.data.responseEnum === 'WRONG_PIN') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'WRONG_PIN';
          } else if (res.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(res.data.responseEnum);
        });
      };
      case this.availableIntegrations.TPAY_EGYPT.name: return (msisdn, operator) => {
        const userMsisdn = msisdn || this.user.msisdn;
        const userOperator = operator || this.user.operator;
        const sCode = localStorage.getItem('sCode');
        const sessionToken = sessionStorage.getItem('sessionToken');
        const refCode = sessionStorage.getItem('refcode');
        this.$axios.get(`api/checkSubscriptionForSms?msisdn=${userMsisdn}&operator=${userOperator}`).then((res) => {
          const response = res.data.responseEnum;
          if (response === 'OPERATION_SUCCESS') {
            sessionStorage.setItem('sms', 'true');
            sessionStorage.setItem('msisdn', res.data.data);
            this.setActiveIntegrationInfo([{ key: 'msisdn', value: res.data.data }, { key: 'operator', value: userOperator }, { key: 'lang', value: this.getLocale }]);
            this.integrationRedirect();
          } else {
            this.$axios.get(`api/addContractRequest?msisdn=${userMsisdn}&lang=${this.getLocale}&referenceCode=${refCode || ''}&operator=${userOperator}&sCode=${sCode || ''}&sessionToken=${sessionToken || ''}`).then((resp) => {
              const responseData = resp.data.data;
              if (responseData.status === 'MSISDN_NOT_EXIST') { // success case (user not exist and about to be registered)
                const masked = responseData.msisdn;
                this.setRegistrationInfo(decodeURIComponent(masked)); // store masked msisdn - decoded
                sessionStorage.setItem('plain', userMsisdn);
                sessionStorage.setItem('subscriptionContractId', responseData.subscriptionContractId);
                this.toggleSelectOperatorModal(false);
                this.$router.push('/register2');
              } else if (responseData.status === 'OPERATION_SUCCESS') { // navigate away case
                const masked = responseData.msisdn;
                this.setRegistrationInfo(decodeURIComponent(masked)); // store masked msisdn - decoded
                this.storeOperator(userOperator);
                this.toggleSelectOperatorModal(false);
                this.$router.push('/register3');
              } else if (responseData.status === 'ALREADY_REGISTERED') {
                localStorage.setItem('sCode', '');
                this.proceedToAutoLogin({
                  query: {
                    user_auth_token: responseData.user_auth_token,
                    username: responseData.username,
                  },
                });
              } else if (responseData.status === 'ALREADY_VERIFIED') { // already sub and registered
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
              } else if (responseData.status === 'INVALID') { // invalid msisdn for operator
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
              } else if (responseData.status === 'MSISDN_BLACKLISTED') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'MSISDN_BLACKLISTED';
              } else if (responseData.status === 'DUPLICATE') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'DUPLICATE';
              } else { // error case
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
              }
            });
          }
        });
      };
      case this.availableIntegrations.KSA_MOBILY.name: return (msisdn, operator) => {
        const userMsisdn = msisdn || this.user.msisdn;
        const userOperator = operator || this.operatorPicked;
        this.$axios.get(`api/requestPinInApp?msisdn=${userMsisdn}&operator=${userOperator}&lang=${this.getLocale}&webflow=true`).then((resp) => {
          if (resp.data.responseEnum === 'OPERATION_SUCCESS') {
            sessionStorage.setItem('msisdn', userMsisdn);
            sessionStorage.setItem('operator', userOperator);
            this.$router.push('/register2');
          } else if (resp.data.responseEnum === 'ALREADY_REGISTERED') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
          } else if (resp.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(resp.data.responseEnum);
        });
      };
      case this.availableIntegrations.ETISALAT_AFG.name: return (msisdn, operator) => {
        const userMsisdn = msisdn || this.user.msisdn;
        const userOperator = operator || this.operatorPicked;
        this.$axios.get(`api/requestPinForAfG?msisdn=${userMsisdn}&heCase=${this.user.heCase}&lang=${this.getLocale}&cid=${this.getCorrelationId}`).then((resp) => {
          if (resp.data.responseEnum === 'OPERATION_SUCCESS') {
            sessionStorage.setItem('msisdn', userMsisdn);
            sessionStorage.setItem('operator', userOperator);
            this.$router.push('/register2');
          } else if (resp.data.responseEnum === 'OPERATION_SUCCESS_FOR_HE') {
            this.proceedToAutoLogin({
              query: {
                user_auth_token: resp.data.data.user_auth_token,
                username: resp.data.data.username,
              },
            });
          } else if (resp.data.responseEnum === 'ALREADY_SUB_USER') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_SUB_USER';
          } else if (resp.data.responseEnum === 'ALREADY_REGISTERED') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
          } else if (resp.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(resp.data.responseEnum);
        });
      };
      default: return null;
      }
    },
    getAlternateVerifyPinAction(ti, ts) {
      switch (this.integrationHeader) {
      case this.availableIntegrations.OMANTEL_OMAN.name:
      case this.availableIntegrations.OOREDOO_OMAN.name: return () => {
        if (this.defaultDailySubButtonEnabled) {
          this.$axios.get(`publicapi/verifyPinDailySubscription?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((response1) => {
            const resp = response1.data.responseEnum;
            this.waitForResponse = false;
            if (resp === 'OPERATION_SUCCESS') { // proceed to authorization
              this.proceedToAutoLogin({ query: { user_auth_token: response1.data.data.user_auth_token, username: response1.data.data.username } });
            } else if (response1.data === 'OLD_PASSWORD_CHANGED') { // here user's password updated
              this.authorizationProcess();
            } else {
              this.showErrorMessage(resp);
            }
          });
        } else {
          this.$axios.get(`publicapi/chargeOneTimeSubscription?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&bundleId=${this.oneTimeSubscriptionBundleId}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((response1) => {
            const resp = response1.data.responseEnum;
            this.waitForResponse = false;
            if (resp === 'OPERATION_SUCCESS') {
              this.proceedToAutoLogin({ query: { user_auth_token: response1.data.data.user_auth_token, username: response1.data.data.username } });
            } else {
              this.showErrorMessage(resp);
            }
          });
        }
      };
      case this.availableIntegrations.ORANGE_SENEGAL.name: return () => {
        this.$axios.get(`publicapi/verifyPinBizao?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&userId=${sessionStorage.getItem('userId')}`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            if (res.data.data.bizaoAlias) {
              sessionStorage.setItem('msisdn', res.data.data.bizaoAlias);
              this.$router.push('register3');
            }
          } else if (res.data.responseEnum === 'ALREADY_REGISTERED') {
            this.proceedToAutoLogin({ query: { user_auth_token: res.data.data.user_auth_token, username: res.data.data.username } });
          } else if (res.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(res.data.responseEnum);
        });
      };
      case this.availableIntegrations.DRC_ORANGE.name: return () => {
        this.$axios.get(`api/verifyPinForLisano?msisdn=${sessionStorage.getItem('msisdn')}&lang=${this.getLocale}&pin=${this.user.pin}&challengeId=${sessionStorage.getItem('challengeId')}&hidden=true`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            this.$router.push('login');
          } else if (res.data.responseEnum === 'ALREADY_REGISTERED') {
            this.proceedToAutoLogin({ query: { user_auth_token: res.data.data.user_auth_token, username: res.data.data.username } });
          } else if (res.data.responseEnum === 'MSISDN_INVALID') {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
          } else {
            this.errors = true;
            this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
          }
          this.mapErrorMessages(res.data.responseEnum);
        });
      };
      case this.availableIntegrations.TPAY_EGYPT.name: return () => {
        const subscriptionContractId = sessionStorage.getItem('subscriptionContractId');
        const plain = sessionStorage.getItem('plain');
        if (sessionStorage.getItem('sms') === 'true') {
          // this.setActiveIntegrationInfo([{ key: 'msisdn', value: sessionStorage.getItem('msisdn') }, { key: 'pin', value: this.user.pin }, { key: 'lang', value: this.getLocale }, { key: 'sms', value: sessionStorage.getItem('sms') }]);
          this.$axios.get(`api/verifyPinForSms?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}`).then((response) => {
            const resp = response.data.responseEnum;
            this.waitForResponse = false;
            if (resp === 'OPERATION_SUCCESS') {
              const subscribedViaWeb = true;
              if (subscribedViaWeb) {
                if (this.multiOperatorInfo.multiOperatorEnabled) {
                  if (this.multiOperatorInfo.operatorPicked.includes('DU')) {
                    this.$gtm.trackEvent({
                      event: 'CompleteRegistrationDU',
                      category: 'MSISDN Registration',
                      action: 'Register 2 registration',
                      label: 'Register 2',
                    });
                  } else {
                    this.sendCompleteRegistrationEvent();
                  }
                } else {
                  this.sendCompleteRegistrationEvent();
                }
              }
              this.setRegistrationInfo(decodeURIComponent(sessionStorage.getItem('msisdn')));
              this.$router.push('register3');
            } else {
              this.showErrorMessage(resp);
            }
          });
        } else {
          this.$axios.get(`api/verifyCodeRequest?plain=${plain}&pin=${this.user.pin}&subscriptionContractId=${subscriptionContractId}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&lang=${this.getLocale}&correlationId=${this.getCorrelationId}&operator=${this.multiOperatorInfo.operatorPicked}`).then((res) => {
            if (res.data.responseEnum === 'OPERATION_SUCCESS') {
              if (res.data.data.status === 'OPERATION_SUCCESS') {
                if (res.data.data.isSub === 'true') { // hasSub
                  this.$gtm.trackEvent({
                    event: 'CompleteRegistration',
                    category: 'MSISDN Registration',
                    action: 'Register 2 registration',
                    label: 'Register 2',
                  });
                }
                localStorage.setItem('sCode', res.data.data.sCode);
                this.$router.push('/register3');
              } else if (res.data.data.status === 'ALREADY_REGISTERED') {
                localStorage.setItem('sCode', '');
                this.proceedToAutoLogin({
                  query: {
                    user_auth_token: res.data.data.user_auth_token,
                    username: res.data.data.username,
                  },
                });
              } else { // error case
                this.hasErrors = true;
                this.waitForResponse = false;
                this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
              }
            } else { // error case
              this.hasErrors = true;
              this.waitForResponse = false;
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            }
          });
        }
      };
      case this.availableIntegrations.KOREK_IRAQ.name: return () => {
        this.$axios.get(`api/verifyPin?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&ti=${ti}&ts=${ts}`).then((response) => {
          const resp = response.data.responseEnum;
          this.waitForResponse = false;
          this.showLoadingModal = true;
          if (resp === 'OPERATION_SUCCESS') {
            this.$axios.get(`api/getStatus?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((res) => {
              this.showLoadingModal = false;
              if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                const hasSub = res.data.data.isSub;
                if (hasSub === 'true') {
                  this.sendCompleteRegistrationEvent();
                }
                this.storeLoginInfo({
                  token: res.data.data.user_auth_token,
                  rememberMeParameter: false,
                  username: res.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              } else { // error case
                this.$router.push('/');
              }
            });
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
              this.message = 'registration_process_with_test_msisdn_perfomed';
            }
            this.showLoadingModal = false;
            this.hasErrors = true;
          }
        });
      };
      case this.availableIntegrations.KSA_MOBILY.name: return () => {
        this.$axios.get(`api/verifyPinInApp?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&ti=${ti}&ts=${ts}&fromWeb=true`).then((response) => {
          const resp = response.data.responseEnum;
          this.waitForResponse = false;
          this.showLoadingModal = true;
          if (resp === 'OPERATION_SUCCESS') {
            this.$axios.get(`api/getStatus?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((res) => {
              this.showLoadingModal = false;
              if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                const hasSub = res.data.data.isSub;
                if (hasSub === 'true') {
                  this.sendCompleteRegistrationEvent();
                }
                this.storeLoginInfo({
                  token: res.data.data.user_auth_token,
                  rememberMeParameter: false,
                  username: res.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              } else { // error case
                this.$router.push('/');
              }
            });
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
              this.message = 'registration_process_with_test_msisdn_perfomed';
            }
            this.showLoadingModal = false;
            this.hasErrors = true;
          }
        });
      };
      case this.availableIntegrations.VODAFONE_QATAR.name: return () => {
        this.$axios.get(`api/verifyPinInApp?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&ti=${ti}&ts=${ts}&fromWeb=true`).then((response) => {
          const resp = response.data.responseEnum;
          this.waitForResponse = false;
          this.showLoadingModal = true;
          if (resp === 'OPERATION_SUCCESS') {
            this.$axios.get(`api/getStatus?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}`).then((res) => {
              this.showLoadingModal = false;
              if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                const hasSub = res.data.data.isSub;
                if (hasSub === 'true') {
                  this.sendCompleteRegistrationEvent();
                }
                this.storeLoginInfo({
                  token: res.data.data.user_auth_token,
                  rememberMeParameter: false,
                  username: res.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              } else { // error case
                this.$router.push('/');
              }
            });
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
              this.message = 'registration_process_with_test_msisdn_perfomed';
            }
            this.showLoadingModal = false;
            this.hasErrors = true;
          }
        });
      };
      // eslint-disable-next-line
      case this.availableIntegrations.ETISALAT_AFG.name: return (msisdn, operator) => {
        this.$axios.get(`api/verifyPin?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}`).then((response) => {
          const resp = response.data.responseEnum;
          this.waitForResponse = false;
          this.showLoadingModal = true;
          if (resp === 'OPERATION_SUCCESS') {
            this.$axios.get(`api/getStatus?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((res) => {
              this.showLoadingModal = false;
              if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                const hasSub = res.data.data.isSub;
                if (hasSub === 'true') {
                  this.sendCompleteRegistrationEvent();
                }
                this.storeLoginInfo({
                  token: res.data.data.user_auth_token,
                  rememberMeParameter: false,
                  username: res.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              } else { // error case
                this.$router.push('/');
              }
            });
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
              this.message = 'registration_process_with_test_msisdn_perfomed';
            }
            this.showLoadingModal = false;
            this.hasErrors = true;
          }
        });
      };
      default:
        return null;
      }
    },
    // ----------- Forgot Password methods ----------------------------------
    alternateForgotProcess() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.TPAY_EGYPT.name: return () => {
        this.$axios.get(`api/checkSubscriptionForSms?msisdn=${this.user.msisdn}&operator=${this.user.operator}`).then((response) => {
          const isReg = response.data.responseEnum === 'ALREADY_REGISTERED';
          if (isReg) this.standardForgotProcess(response.data.data);
          else if (response.data.responseEnum === 'MSISDN_INVALID') {
            this.message = 'visitor_forgot_password_invalid_msisdn_msg';
            this.hasErrors = true;
          } else {
            sessionStorage.setItem('forgotMsisdn', this.user.msisdn);
            sessionStorage.setItem('forgotOperator', this.user.operator);
            window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?callBack=/forgotPassword1&lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
          }
        });
      };
      default: return () => {
        // eslint-disable-next-line
        console.log('No forgot action check for active integration: ' + this.integrationHeader);
      };
      }
    },
    standardForgotProcess(msisdn) {
      sessionStorage.setItem('altMode', 'false');
      this.$axios.get(`api/requestNewPin?msisdn=${msisdn || this.user.msisdn}&lang=${this.getLocale}&operator=${this.user.operator}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.setForgotPasswordInfo(response.data.data);
          this.getNextForgotPasswordStep()();
          this.user.msisdn = '';
          this.message = '';
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_forgot_password_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_forgot_password_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_forgot_password_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_forgot_password_msisdn_blacklisted';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'CAMPAIGN_CLOSED') {
            this.message = 'visitor_sign_up_campaign_closed';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    alternateForgotVerifyPinProcess() {
      const hasAlt = sessionStorage.getItem('altMode') === 'true';
      if (!hasAlt) this.standardForgotVerifyPinProcess();
      else {
        const subscriptionContractId = sessionStorage.getItem('subscriptionContractId');
        const plain = sessionStorage.getItem('plain');
        this.$axios.get(`api/verifyCodeRequest?plain=${plain}&pin=${this.pin}&subscriptionContractId=${subscriptionContractId}&msisdn=${this.forgotPasswordInfo}&lang=${this.getLocale}&correlationId=${this.getCorrelationId}&operator=${this.multiOperatorInfo.operatorPicked}`).then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            if (res.data.data.status === 'OPERATION_SUCCESS') {
              if (res.data.data.isSub === 'true') { // hasSub
                this.$gtm.trackEvent({
                  event: 'CompleteRegistration',
                  category: 'MSISDN Registration',
                  action: 'Register 2 registration',
                  label: 'Register 2',
                });
              }
              localStorage.setItem('sCode', res.data.data.sCode);
              this.setRegistrationInfo(this.forgotPasswordInfo);
              this.$router.push('/register3');
            } else if (res.data.data.status === 'ALREADY_REGISTERED') {
              localStorage.setItem('sCode', '');
              this.proceedToAutoLogin({ query: { user_auth_token: res.data.data.user_auth_token, username: res.data.data.username } });
            } else { // error case
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            }
          } else { // error case
            this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
          }
        });
      }
    },
    standardForgotVerifyPinProcess() {
      this.$axios.get(`api/verifyPinForForgotPassword?msisdn=${this.forgotPasswordInfo}&pin=${this.pin}`).then((response) => {
        const resp = response.data.responseEnum;
        if (resp === 'OPERATION_SUCCESS') {
          this.setHashedPassForForgotPass(response.data.data.hashedPass);
          this.$router.push('forgotPassword3');
          this.message = '';
        } else {
          if (resp === 'PIN_EXPIRED') {
            this.message = 'visitor_sign_up_2_pin_expired';
          } else if (resp === 'WRONG_PIN') {
            this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
          } else if (resp === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (resp === 'SERVER_ERROR') {
            this.message = 'SERVER_ERROR';
          } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },

    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubAction() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.DU_ETISALAT.name: return (msisdn, operator) => {
        this.$axios.get(`api/getReSubUrl?msisdn=${msisdn}&operator=${operator}`).then((response) => {
          window.location.href = response.data.data;
        });
      };
      case this.availableIntegrations.TPAY_EGYPT.name: return () => {
        this.clearLoginInfo(); // logout
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
      };
      case this.availableIntegrations.ORANGE_SENEGAL.name: return () => {
        this.clearLoginInfo(); // logout
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&msisdn=${this.$route.query.msisdn}&operator=${this.$route.query.operator}`;
      };
      case this.availableIntegrations.KSA_MOBILY.name: return () => {
        this.clearLoginInfo(); // logout
        window.location.href = `${window.location.origin}/api/getRegisterUrl?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}&lang=${this.getLocale || ''}`;
      };
      case this.availableIntegrations.ETHIOTEL_ETHIOPIA.name: return () => {
        this.clearLoginInfo();
        window.location.href = `${window.location.origin}/api/getRegisterUrl?lang=${this.getLocale || ''}&reoptin=true`;
      };
      case this.availableIntegrations.AIRTEL_NIGERIA.name: return (msisdn) => {
        this.$axios.get(`api/requestReoptin?msisdn=${msisdn}&lang=${this.getLocale}`).then((response) => {
          // eslint-disable-next-line
          console.log(response);

          this.reSubCallback(response); // the component that want to use it, should implement it
        });
      };
      case this.availableIntegrations.ETISALAT_AFG.name: return () => {
        // eslint-disable-next-line
        this.$axios.get(`api/requestPinForAfG?msisdn=${msisdn}&webFlow=true&lang=${this.getLocale}`).then((response) => {
          // eslint-disable-next-line
          this.reSubCallback(response); // the component that want to use it, should implement it
        });
      };
      case this.availableIntegrations.YOU_YEMEN.name: return (msisdn) => {
        this.$axios.get(`api/alternativeReoptin?msisdn=${msisdn}&lang=${this.getLocale}&webFlow=true`).then((response) => {
          // eslint-disable-next-line
          console.log(response);
          this.reSubCallback(response); // the component that want to use it, should implement it
        });
      };
      default: return () => {
        // eslint-disable-next-line
        console.log('No presub action check for active integration: ' + this.integrationHeader);
      };
      }
    },
    clearLoginInfo() {
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null) {
        currentLocale = this.getLocale;
      }
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0) {
        // in order to know the last log in time
        sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      }
      this.clearAllData();
    },
    standardReSubAction() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      return this.reOptinProcess();
    },
    getAppropriateReSubAction() {
      const DuName = this.multiOperatorInfo.multiOperatorKeys.filter(item => item.includes('DU'))[0];
      const activeIntegration = this.getIntegrationByName();
      if ((activeIntegration && activeIntegration.value.hasThirdPartyReSub) && this.userDetails.operatorName === DuName) {
        this.alternateReSubAction()(this.userDetails.msisdn, this.userDetails.operatorName);
      } else if (activeIntegration.value.name === this.availableIntegrations.YOU_YEMEN.name) {
        this.alternateReSubAction()(this.userDetails.msisdn, this.userDetails.operatorName);
      } else if (activeIntegration.value.name === this.availableIntegrations.AIRTEL_NIGERIA.name) {
        this.alternateReSubAction()(this.userDetails.msisdn, this.userDetails.operatorName);
      } else if (activeIntegration.value.name === this.availableIntegrations.ETHIOTEL_ETHIOPIA.name) {
        this.alternateReSubAction()();
      } else if (activeIntegration && activeIntegration.value.hasHeReSub) {
        this.alternateReSubAction()(); // alternate resub for HE, no need for msisdn, operator params
      } else {
        this.standardReSubAction().then((response) => {
          this.reSubCallback(response); // the component that want to use it, should implement it
        });
      }
    },
    getPostReSubAction() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.VODACOM.name:
        return (callback) => {
          this.$axios.get('api/getUsageAuthRateUrl').then((res) => {
            const parsedResponse = JSON.parse(res.data.data);
            if (parsedResponse.result === 'UNSUB') { // if user is un-sub to vodacom
              const packageId = parsedResponse.packageId;
              this.$axios.get(`${this.REGISTRATION_ENDPOINT}?packageId=${packageId}`).then((response) => {
                const responseEnum = response.data.responseEnum;
                let redirectionUrl = response.data.data;
                if (responseEnum === 'OPERATION_SUCCESS' && redirectionUrl) {
                  if (callback) {
                    redirectionUrl = auth.replaceUrlParameterValue(redirectionUrl, 'partner-redirect-url', callback);
                  }
                  window.location.href = redirectionUrl;
                }
              });
            }
          });
        };
      default:
        return () => {
          // eslint-disable-next-line
          console.log('No action needed for active integration: ' + this.integrationHeader);
        };
      }
    },
    getReSubParametersCheck() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.VODACOM.name:
        return (to) => {
          if (to.query.result && to.query['status-code']) {
            if ((to.query.result === 'ACCEPTED' && to.query['status-code'] === '0') || to.query['status-code'] === '7') { // success case
              this.$router.push('/');
            } else {
              this.errorStatusCode = to.query['status-code'];
              this.SHOW_HE_ERROR_RESPONSE_CODE_MESSAGE = true;
            }
          }
        };
      default:
        return (to) => {
          // eslint-disable-next-line
          console.log('No parameter check ( parameters: ' + to.query + ') for active integration: ' + this.integrationHeader);
        };
      }
    },
    getPostUnSubAction() {
      switch (this.integrationHeader) {
      case this.availableIntegrations.VODACOM.name: return () => {
        this.$axios.get('api/getUsageAuthRateUrl').then((res) => {
          const parsedResponse = JSON.parse(res.data.data);
          if (parsedResponse.result === 'ALREADY_SUB') { // if user is un-sub to vodacom
            const subId = parsedResponse.subscriptionId;
            if (subId) this.$axios.get(`api/unSubUserFromPartner?subscriptionId=${subId}`);
          }
        });
      };
      default: return () => {
        // eslint-disable-next-line
        console.log('No action needed for active integration: ' + this.integrationHeader);
      };
      }
    },

    // ------------- integration helper methods -----------------------------------
    hasResub() {
      return this.getIntegrationByName() && this.getIntegrationByName().value.resubOnForgot;
    },
    getIntegrationByName(name = this.integrationHeader) {
      if (!name) {
        return '';
      }
      const integrationKey = Object.keys(this.availableIntegrations).find(key => this.availableIntegrations[key].name === name);
      return { key: integrationKey, value: this.availableIntegrations[integrationKey] };
    },
    registerCheck(msisdn) {
      return this.getUserExistsInCore(msisdn).then((response) => {
        if (response.data) {
          this.getUserIsRegistered(msisdn).then((res) => {
            if (res.data) {
              this.$router.push('login');
            } else {
              this.$router.push('register3');
            }
          });
        } else {
          this.$router.push('/');
        }
      });
    },
    setActiveIntegrationInfo(info) {
      this.updateIntegrationInfo({ name: this.getIntegrationByName().key, value: info });
    },
    toggleSelectOperatorModal(value) {
      this.setShowSelectOperatorModal({ value });
    },
    getSelectOperatorModalChoice() {
      return this.showSelectOperatorModal;
    },
    hasExternalRedirection() {
      return this.getIntegrationByName() && this.getIntegrationByName().value.hasExternalRedirection;
    },
    hidePage() {
      return this.getIntegrationByName() && this.getIntegrationByName().value.hidePage;
    },
  },
  computed: {
    ...mapState('common', [
      'oneTimeSubscriptionBundleId',
      'defaultDailySubButtonEnabled',
      'fbReferral',
      'banner',
      'integrationHeader',
      'multiOperatorInfo',
      'availableIntegrations',
      'showSelectOperatorModal',
      'userDetails',
    ]),
    ...mapGetters('common', [
      'getClickId',
      'getRefUrl',
      'getCampaignId',
      'getPublisherId',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
  },
};

export default IntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integration.js